/**
 * Endpoint methods related to the Customer Settings & General Settings
 */
 import API from "./Api";

export default {
    /**
    * Creates a new General Setting
    */
    async create(form) {
        return API.post("/settings/create", form, "COOKIE_TOKEN_JSON");
    },

    /**
    * Gets all the General Settings
    */
    async get() {
        return API.get("/settings/read", {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          }
        });
    },

    /**
     * [PUBLIC ENDPOINT]
    * Gets a filtered set of Cutomer and General Settings
    */

    async getFiltered(form) {
      return API.post("/settings/readfiltered", form, {
        
      });
    },

    /**
     * [PUBLIC ENDPOINT]
    * Gets all the Customer and General Settings
    */
    async getAll() {
      return API.get("/settings/readall", "PLAIN_JSON");
    },

    /**
    * Updates a General Setting
    */
    async update(form) {
        return API.put(`/settings/update/`, form, "COOKIE_TOKEN_JSON");
    },

    /**
    * Deletes a General Setting
    */
    async delete(form) {
        return API.post(`/settings/delete/`, form, "COOKIE_TOKEN_JSON");
    }
}